import React, { useRef, useState,useEffect } from 'react'

import {useOnScroll} from "jd-library"

import styles from './add-dc-button-button.scss'
import { useDispatch, useSelector } from 'react-redux'
import { clickTrack, toggleAddEditButtonAnimation } from '../../actions/products'


const AddDCButton = (props) => {
    const [icons, toggleIcons] = useState(false)
    const [isScrolled,setIsScroll]=useState(false)
    const timeOutRef=useRef(null);
    const dispatch = useDispatch();
    const showShimmer = useSelector(state => state.products.listing.showShimmer);
    
    useEffect(() => {
      setTimeout(() => {
        dispatch(
          toggleAddEditButtonAnimation({
            isAddEditButtonAnimation: false,
          })
        );
      }, 5000);
    }, []);

    useOnScroll({
		callback: (e,a)=>{
            setIsScroll(true)
            if(timeOutRef.current) clearTimeout(timeOutRef.current)
            timeOutRef.current=setTimeout(() => {
                setIsScroll(false)
            }, 500);
        },
	});

    const onBtnClick = (rotateStatus) => {
        if(rotateStatus && !props.viaOmni) {
            dispatch(clickTrack({li: 'dc_add_click',ll: 'digital_catalog', userBasedCheck: true}));
        }
        toggleIcons(rotateStatus);
    }   
    return (
        <div className={`${styles["container"]} ${props.hasGlassFooter ? 'ubl-footer-css' : ''}`}>
            {(!icons && props.actualProdCount == 1 && !showShimmer) && <div className={`${props.isAddEditButtonAnimation ? styles.tooltipalert : styles.tooltipalert_no_ani} `}>
                <p>Add more</p>
                <p className={`${styles.pbold}`}>{props.profileObject.PluralLabelWithSpace}</p>
                <p>for your buyers!</p>
            </div>}
            <button className={`${icons ? "cross_btn rotate active icon-plus" : "cross_btn icon-plus"} ${isScrolled?'scrolled':''} ${( props.appVersion >= '3.3' && props.isJdBusinessIOS) ? 'ubl-plus-icon' : ''}`} onClick={() => onBtnClick(!icons)}>
                <i className={styles["cross_icon"]}></i>
                {
                    !isScrolled && <span className="add_btn">Add</span>
                }                
            </button>
            <div className={styles["add_wrapper"]}>
                <ul className={styles["add_product_ul"]} role="menu">
                    {props.iconData.map((icon,index)=>{
                        return(icon != false && (<li
                                                role="menuitem"
                                                tabIndex={icons ? 0 : -1}
                                                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { icon.iconAction(); toggleIcons(!icons); } }}
                                                onClick={() => {
                                                    icon.iconAction();
                                                    toggleIcons(!icons)
                                                }}>
                            <span className={styles["add_product_wrap"]} >
                                <span className={styles["prinfo font14"]}>{icon?.label || ''}</span>
                                <span className={styles["add_mywatchlist_icon pbiconbx"]}></span>
                            </span>
                            <span className='iconHolder'><i className={icon?.iconClass || 'icon-Info'}></i></span>
                        </li>))
                    })}
                </ul>
            </div>
            <span class="add_product_bg"></span>
        </div>
    )
}

export default AddDCButton